module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/mcm7L1/tc-custom/9780310412625.jpg?1718072593616",
      "alt": "This image is the cover for the book Eye for Glory"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Eye for Glory\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Michael palmer is a good man, a family man. But honor and duty push him to leave his comfortable life and answer the call from Abraham Lincoln to fight for his country.  This “citizen soldier” learns quickly that war is more than the battle on the field. Long marches under extreme conditions, illness, and disillusionment challenge at every turn.  Faith seems lost in a blur of smoke and blood … and death. Michael’s only desire is to kill as many Confederate soldiers as he can so he can go home. He coldly counts off the rebels that fall to his bullets. Until he is brought up short by a dying man holding up his Bible. It’s in the heat of battle at Gettysburg and the solemn aftermath that Michael begins to understand the grave cost of the war upon his soul. Here the journey really begins as he searches for the man he was and the faith he once held so dearly. With the help of his beloved wife, Jesse Ann, he takes the final steps towards redemption and reconciliation.Using first-hand accounts of the 14th Connecticut Infantry, Karl Bacon has crafted a detailed, genuine and compelling novel on the 150th anniversary of the Civil War. Intensely personal and accurate to the times, culture, and tragedy of the Civil War, An Eye for Glory may change you in ways you could have never imagined as well.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Karl A. Bacon\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Karl Bacon is a first time novelist, but long time student of the Civil War.  He and his wife, Jackie live in Naugatuck, Connecticut.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Zondervan\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0